/** App-owned timings, page sizes and storage keys; network facts and policy stay in API answers. */
export const timing = {
  wallet: {
    discoveryWaitMs: 0,
    userActionTimeoutMs: 180_000,
    readTimeoutMs: 20_000,
    restoreTimeoutMs: 8_000,
    orphanWatchMs: 5 * 60_000 + 30_000,
  },
  ownerCall: {
    reportRetryMs: 3_000,
    reportTimeoutMs: 10 * 60_000,
    unansweredAttempts: 5,
    receiptRetryMs: 3_000,
    receiptTimeoutMs: 10 * 60_000,
  },
  rebalancing: { appliedPollMs: 10_000 },
  pairs: { pendingPollMs: 10_000, priceSource: { pollMs: 15_000 } },
  feedCheck: { debounceMs: 400 },
  feedDirectory: { timeoutMs: 15_000 },
  telegram: { pollMs: 5_000, tickMs: 1_000 },
  ui: { copiedMs: 1_500, chainDownRetryMs: 30_000 },
};

export const errorReporting = { flushIntervalMs: 10_000, maxBatchSize: 20, maxQueueSize: 100, maxSendAttempts: 3 };

export const pageSizes = { orders: 20, transactions: 10, events: 100 };

export const storageKeys = {
  session: "aile.maker.session",
  network: "aile.maker.network",
  walletSelection: "aile.maker.wallet.rdns",
  walletConnectUnclean: "aile.maker.wallet.wcUnclean",
  legacyAuth: "aile.auth",
  legacyApiKeys: "aile.apiKeys",
  legacyCompanyKey: "aile.companyKey",
} as const;
